import { Autocomplete, TextField } from '@mui/material';

export interface SearchableSelectOption {
  value: string;
  label: string;
}

interface SearchableSelectProps {
  label: string;
  value: string;
  options: SearchableSelectOption[];
  onChange: (value: string) => void;
  allLabel?: string;
  disabled?: boolean;
  width?: number | string | Record<string, number | string>;
}

/** A compact filter dropdown that can also be searched by typing. */
export function SearchableSelect({
  label,
  value,
  options,
  onChange,
  allLabel,
  disabled = false,
  width = 180,
}: SearchableSelectProps): JSX.Element {
  const selected = options.find((option) => option.value === value) ?? null;
  return (
    <Autocomplete
      size="small"
      options={options}
      value={selected}
      disabled={disabled}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, current) => option.value === current.value}
      onChange={(_, option) => onChange(option?.value ?? '')}
      noOptionsText="No matching option"
      sx={{ width }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={!selected ? allLabel : undefined} />
      )}
    />
  );
}
